/* START -- 3 Block - 2 small 1 big Section Loading Video Cover */

var sec3ItemsLoadVideo = function(elem) {
  var parentVideoCont = elem.parentElement.parentElement;
  var videoCont = document.createElement('div');
  /*var videoElement = document.createElement('video');*/
  videoCont.classList = "section-3-elements__container-grids__container-grid__container-absolute-video";
  var videoSrcFound = false;
  var videoSrc = false;
  if(innerWidth < 768){
    if(elem.getAttribute("data-vMob") != "false" ) {
      videoSrc = elem.getAttribute("data-vMob");
      videoSrcFound = true;
    }
  } else if (innerWidth < 992) {
    if(elem.getAttribute("data-v768") != "false" ) {
      videoSrc = elem.getAttribute("data-v768");
      videoSrcFound = true;
    }
  } else if (innerWidth < 1200) {
    if(elem.getAttribute("data-v992") != "false" ) {
      videoSrc = elem.getAttribute("data-v992");
      videoSrcFound = true;
    }
  } else if (innerWidth < 1920) {
    if(elem.getAttribute("data-v1200") != "false" ) {
      videoSrc = elem.getAttribute("data-v1200");
      videoSrcFound = true;
    }
  } else if (innerWidth >= 1920) {
    if(elem.getAttribute("data-v1920") != "false" ) {
      videoSrc = elem.getAttribute("data-v1920");
      videoSrcFound = true;
    }
  }
  console.log(videoSrcFound);
  if(videoSrcFound) {
    var videoElem = `<video muted loop playsinline autoplay><source src="${videoSrc}" type="video/mp4"></video>`;
    videoCont.innerHTML = videoElem;
    if( parentVideoCont.getElementsByClassName('section-3-elements__container-grids__container-grid__container-absolute-video').length > 0 ){
      parentVideoCont.getElementsByClassName('section-3-elements__container-grids__container-grid__container-absolute-video')[0].remove();
    }
    parentVideoCont.appendChild(videoCont);
  } else {
    if( parentVideoCont.getElementsByClassName('section-3-elements__container-grids__container-grid__container-absolute-video').length > 0 ){
      parentVideoCont.getElementsByClassName('section-3-elements__container-grids__container-grid__container-absolute-video')[0].remove();
    }
  }
}

/* END -- 3 Block - 2 small 1 big Section Loading Video Cover */